import { matchPath } from "react-router";

/**
 * Routes that opt out of the 1280 px content column:
 * - the feature-flag comparison table;
 * - the echo detail page (its Director View stage is a side-by-side player +
 *   original at cinema size);
 * - Marketing & acquisition (UX-00): a 12-column analytics workspace with
 *   its own 2200 px container, and its legacy view.
 */
const FULL_WIDTH_PATTERNS = [
  "/feature-flags/*",
  "/echoflicks_echoes/:id/show",
  "/marketing",
  "/marketing/legacy",
] as const;

export function layoutUsesFullWidth(pathname: string): boolean {
  return FULL_WIDTH_PATTERNS.some((pattern) =>
    Boolean(matchPath(pattern, pathname)),
  );
}
